module.exports = __webpack_public_path__ + "static/img/KEYBOARD.af285427.png";